import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { XsMessageBoxComponent } from 'src/app/common/widgets/xs-message-box/xs-message-box.component';
import { ContactoService } from '../../services/contacto.service';
import { ArchivoService } from '../../services/archivo.service';
import { SolicitudService } from '../../services/solicitud.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppTitleService } from 'src/app/common/services/xs-app-title';

export interface parametro {
  opcion: string;
  idSolicitud: number;
  idSolicitudDetalle: number;
  idSubsector: string;
}

@Component({
  selector: 'app-contacto-detalle',
  templateUrl: './contacto-detalle.component.html',
  styleUrls: ['./contacto-detalle.component.css']
})
export class ContactoDetalleComponent implements OnInit {

  listaEstado = [];
  solicitud: any = {};
  file: any = {};
  nombreArchivo: string;
  click: boolean = true;
  cargaArchivo: boolean = false;
  idSubsector: string;
  permiso: string;
  usuarioCrea = "";
  url: string = "";
  urlSafe: SafeResourceUrl;
  htmlString;
  idArchivo = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public parametro: parametro,
    public solicitudService: SolicitudService,
    public archivoService: ArchivoService,
    public xsAppConfigService: XsAppConfigService,
    public dialogRef: MatDialogRef<ContactoDetalleComponent>,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    public appTitleService: AppTitleService,
  ) { }

  ngOnInit() {
    this.idSubsector = this.xsAppConfigService.ID_SUBSECTOR;
    this.permiso = this.xsAppConfigService.APLICACION_PERFIL;
    this.inicializar();
  }

  inicializar() {
    this.parametro.idSubsector = this.idSubsector;
   /* this.solicitudService.consultarContacto(this.parametro).then(res => {
      this.listaEstado = res.data.listaEstado;
      this.solicitud = res.data.solicitudDetalle;
      this.nombreArchivo = "Archivo Cargado: " + this.solicitud.nombreArchivo;
      if (res.data.estado && this.permiso == 'ADMINISTRADO') {
        if (this.parametro.opcion == "MODIFICAR") {
          this.idArchivo = this.solicitud.idArchivo;
        }
        this.loadIframe();
      }
    });*/
  }

  onFileChanged(event) {
    if (!this.validarFile(event)) {
      this.file = null;
      this.nombreArchivo = "";
      return;
    }
    const file = event.target.files[0];
    this.file = file;
    this.nombreArchivo = "Archivo Cargado: " + event.target.files[0].name;
    this.cargaArchivo = true;
  }

  loadIframe() {
    if(this.permiso == "ADMINISTRADO"){
      this.usuarioCrea = this.solicitud.nroDocumento;
    }
    else {
      this.usuarioCrea = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    }
    let params = {
      opcion: this.parametro.opcion,
      pathAlfresco: 'file.path.contacto.administrado',
      idArchivo: this.idArchivo,
      audUsuarioCrea: this.usuarioCrea
    };
   /* this.archivoService.agregarArchivo(params).then(res => {
      if (res.data.estado) {
        // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.urlIframe);
        this.htmlString = this.sanitizer.bypassSecurityTrustHtml(res.data.archivoHtml);
        this.idArchivo = res.data.idArchivo;
      }
    });*/
  }

  titulo() {
    return this.appTitleService.getTitle(this.xsAppConfigService.ID_SUBSECTOR, "CONTACTOS DE ADMINISTRADO", this.parametro.opcion);
  }

  /*-----------------------------------------------------------------*/
  /*---------------------------- EVENTOS ----------------------------*/
  /*-----------------------------------------------------------------*/
  onClickAceptar() {
    this.solicitud.idSolicitud = this.parametro.idSolicitud;
    this.solicitud.idSubsector = this.idSubsector;
    this.solicitud.idArchivo = this.idArchivo;
    switch (this.parametro.opcion) {
      case "AGREGAR":
        this.click = false;
        if (!this.validarCampo()) {
          this.click = true;
          return;
        }
        var formData = new FormData();
        formData.append("path", "file.path.contacto.administrado");
        /*this.archivoService.agregarArchivo0(formData, this.file).then(res => {
          if (res.data.estado == true) {
            this.solicitud.idArchivo = res.data.idArchivo;
          }
          this.solicitudService.agregarDetalle(this.solicitud).then(res => {
            this.dialogRef.close({ data: null, estado: "ACEPTAR" });
          });
        });*/
        break;
      case "MODIFICAR":
        this.click = false;
        if (!this.validarCampo()) {
          this.click = true;
          return;
        }
        var formData = new FormData();
        formData.append("path", "file.path.contacto.administrado");
        if (this.solicitud.idArchivo == null) {
          this.solicitud.idArchivo = 0;
        }
        formData.append("idArchivo", this.solicitud.idArchivo);
        formData.append("uiid", this.solicitud.uiid);
        /*this.archivoService.modificarArchivo(formData, this.file).then(res => {
          if (res.data.estado == true && res.data.idArchivo != null) {
            this.solicitud.idArchivo = res.data.idArchivo;
          }
          this.solicitudService.modificarDetalle(this.solicitud).then(res => {
            this.dialogRef.close({ data: null, estado: "ACEPTAR" });
          });
        });*/
        break;
      default:
        this.mostrarMensajeDialog("Opps. Lo siento no supe que hacer con su solicitud, por favor intentalo nuevamente ;)")
        break;
    }
  }

  onClickCancelar() {
    if (this.parametro.opcion == "AGREGAR"){
      let params = {
        idArchivo: this.idArchivo
      };
    //  this.archivoService.eliminarArchivo(params).then(res => { });
    }
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }

  /*-------------------------------------------------------------------------*/
  /*---------------------------- DIALOGO (MODAL) ----------------------------*/
  /*-------------------------------------------------------------------------*/
  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  /*---------------------------------------------------*/
  /*---------------VALIDACIÓN DE CAMPOS----------------*/
  /*---------------------------------------------------*/

  validarCampo() {
    var errores = "";
    // if (this.parametro.opcion == 'AGREGAR' && this.nombreArchivo == 'Archivo Cargado: null') {
    //   errores = "<br>Ingrese un documento";
    // }
    if (!this.solicitud.correo) {
      errores = "<br>Ingrese correo del contacto";
    }
    if (!this.solicitud.nombres) {
      errores = "<br>Ingrese los nombres del contacto";
    }
    if (!this.solicitud.apellidos) {
      errores = "<br>Ingrese los apellidos del contacto";
    }
    if (!this.solicitud.activo) {
      errores = "<br>Seleccione el estado";
    }
    if (errores != "") {
      this.mostrarMensajeDialog(errores);
    }
    return errores == "";
  }

  validarFile(file) {
    var errores = "";
    if (this.getFileExtension(file) != "pdf" && this.getFileExtension(file) != "zip" && this.getFileExtension(file) != "rar") {
      errores = "<br>El archivo seleccionado no esta permitido";
    }
    if (file.target.files[0].size / 1024 > (parseInt("500") * 1024)) {
      errores = "<br>El tamaño del archivo no debe superar a los 500 MB";
    }
    if (file.target.files[0].name.length > 50) {
      errores = "<br>El nombre del archivo no debe exceder a los 50 caracteres";
    }

    if (errores != "") {
      this.mostrarMensajeDialog(errores);
    }
    return errores == "";
  }

  getFileExtension(file) {
    var filename = file.target.files[0].name;
    var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    return ext;
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

}
